export const getFirebaseLists = (state) => state.firebase.myLists;
